/* Kaffe & Thehuset – "Tilføj" direkte fra produktkort */
(function () {
	if (window.__ktQuickAdd) return;
	window.__ktQuickAdd = true;
	var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
	var open = null; /* { opts, toggle, home, host, leave } */
	var overlay = null;

	function isPhone() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; }

	function closeAll() {
		if (!open) return;
		var o = open;
		open = null;
		o.opts.hidden = true;
		o.opts.classList.remove('is-sheet');
		o.toggle.setAttribute('aria-expanded', 'false');
		if (o.leave) o.host.removeEventListener('mouseleave', o.leave);
		if (o.home && o.home.parentNode) { o.home.parentNode.insertBefore(o.opts, o.home); o.home.parentNode.removeChild(o.home); }
		if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
		document.documentElement.classList.remove('kt-qa-lock');
	}

	function openFor(toggle) {
		var opts = toggle.parentNode.querySelector('.kt-qa__opts');
		if (!opts) return;
		var o = { opts: opts, toggle: toggle, home: null, host: toggle.closest('.card-wrapper') || toggle.closest('[data-kt-qa]'), leave: null };
		if (isPhone()) {
			/* På mobil vises valgene som et vindue nedefra, så man kan scrolle frit */
			o.home = document.createComment('kt-qa');
			opts.parentNode.insertBefore(o.home, opts);
			if (!overlay) { overlay = document.createElement('div'); overlay.className = 'kt-qa-overlay'; }
			document.body.appendChild(overlay);
			document.body.appendChild(opts);
			opts.classList.add('is-sheet');
			document.documentElement.classList.add('kt-qa-lock');
		} else if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
			/* Luk når musen forlader produktet */
			o.leave = function () { closeAll(); };
			o.host.addEventListener('mouseleave', o.leave);
		}
		opts.hidden = false;
		opts.scrollTop = 0;
		toggle.setAttribute('aria-expanded', 'true');
		open = o;
	}

	function add(btn, id) {
		var label = btn.innerHTML;
		btn.disabled = true;
		btn.classList.add('is-loading');
		var drawer = document.querySelector('cart-drawer');
		var hasDrawer = drawer && typeof drawer.renderContents === 'function';
		var body = { items: [{ id: Number(id), quantity: 1 }] };
		if (hasDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
		fetch(shopRoot + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify(body)
		})
			.then(function (r) { return r.json(); })
			.then(function (res) {
				btn.classList.remove('is-loading');
				if (res.status) { btn.textContent = 'Udsolgt'; return; }
				btn.classList.add('is-added');
				btn.textContent = 'Tilføjet ✓';
				closeAll();
				if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
				if (hasDrawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
				else { window.location.href = shopRoot + 'cart'; return; }
				setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.innerHTML = label; }, 1800);
			})
			.catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; });
	}

	document.addEventListener('click', function (e) {
		var toggle = e.target.closest('[data-kt-qa-toggle]');
		if (toggle) {
			e.preventDefault();
			e.stopPropagation();
			var wasOpen = open && open.toggle === toggle;
			closeAll();
			if (!wasOpen) openFor(toggle);
			return;
		}
		if (e.target.closest('[data-kt-qa-close]') || e.target.classList.contains('kt-qa-overlay')) {
			e.preventDefault();
			e.stopPropagation();
			closeAll();
			return;
		}
		var btn = e.target.closest('[data-kt-qa-add]');
		if (btn) {
			e.preventDefault();
			e.stopPropagation();
			if (!btn.disabled) add(btn, btn.getAttribute('data-kt-qa-add'));
			return;
		}
		if (open && !e.target.closest('[data-kt-qa]') && !e.target.closest('.kt-qa__opts')) closeAll();
	}, true);
	document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeAll(); });
})();
